import React, { useEffect, useRef, useState } from "react";

import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import TestImg1 from "../Images/TestimonialImg/Testimonial1.jpg";
import TestImg2 from "../Images/TestimonialImg/Testimonial2.jpg";
import TestImg3 from "../Images/TestimonialImg/Testimonial3 .jpg";
import TestImg4 from "../Images/TestimonialImg/Testimonial4.jpg";
import TestImg5 from "../Images/TestimonialImg/Testimonial5.jpg";
import TestImg6 from "../Images/TestimonialImg/Testimonial6.jpg";
import TestImg7 from "../Images/TestimonialImg/Testimonial7.jpg";
import TestImg9 from "../Images/TestimonialImg/shivani.jpeg";
const Testimonials = () => {
  const [testimonials, setTestimonials] = useState();
  const testinomialRef = useRef(null);

  const scrollByCard = (ref, direction) => {
    if (!ref.current) return;
    const card = ref.current.querySelector("div");
    if (!card) return;
    const cardWidth = card.offsetWidth + 40;
    ref.current.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
  };

  useEffect(() => {
    setTestimonials([
      {
        img: TestImg1,
        category: "Category",
        content:
          "SEOBIX has been really helpful in improving my social media and digital growth. After working with them, I’ve seen better results and more online reach. Their smo tools are  professional, and easy to use . I’m happy with their service.",

        author: "Vanshika Paliwal",
        designation: "Social Media Executive",
        review: "★★★★★",
      },

      {
        img: TestImg5,
        category: "Category",
        content:
          "As a Google Ads expert, I like using Seobix because it helps fix landing page issues fast. It shows what’s wrong, gives easy keyword tips, and helps improve ad quality and reduce cost-per-click.",

        author: "Parth Khandelwal",
        designation: "Google Ads Specialist",
        review: "★★★★☆",
      },
      {
        img: TestImg9,
        category: "Category",
        content:
          "I had a great experience with SEOBIX.com. Their SEO tools are easy to use, and their team supported me at every step. I saw real results on my website through their live project work. Highly recommend them for SEO services.",

        author: "Shivani Sengar",
        designation: "SEO Analyst",
        review: "★★★★★",
      },
      {
        img: TestImg3,
        category: "Category",
        content:
          " As an SEO executive, Seobix helps me quickly audit websites and fix SEO issues. Its keyword and backlink tools make my daily tasks easier. It’s a smart and time-saving tool",
        author: "Harsh Goel",
        designation: "SEO Executive",
        review: "★★★★★",
      },
      {
        img: TestImg2,
        category: "Category",
        content:
          " As a digital marketing specialist, Seobix helps me improve website performance and SEO easily. It gives clear reports on site issues, keywords, and backlinks. It's a simple and effective tool for better online results. ",

        author: "Himashu Phulara",
        designation: "Digital Marketing Specialist",
        review: "★★★★★",
      },
      {
        img: TestImg4,
        category: "Category",
        content:
          "As a content specialist, Seobix helps me find the right keywords and improve content for SEO. It shows what to fix to make content rank better. Simple, fast, and very useful tool.",

        author: "Amit Yadav",
        designation: "Content Strategist",
        review: "★★★★★",
      },

      {
        img: TestImg6,
        category: "Category",
        content:
          "As an SEM Executive, I gained hands-on experience in managing paid campaigns and analyzing performance metrics. It helped me understand audience behavior, keyword strategy, and how to drive targeted traffic effectively.  ",

        author: "Tanishka Gurtoo",
        designation: "SEM Executive",
        review: "★★★★☆",
      },
      {
        img: TestImg7,
        category: "Category",
        content:
          " As an SEO specialist, Seobix helps me find and fix website problems easily.Its keyword and backlink tools are simple to use. It saves time and improves website ranking.",

        author: "Raghav Rajoria",
        designation: "SEO Specialist",
        review: "★★★★★",
      },
    ]);
  }, []);

  return (
    <div>
      <h2
        style={{
          fontSize: "2.2rem",
          fontWeight: "700",
          fontFamily: "'Poppins', sans-serif",
          textAlign: "center",
          color: "#003366",
          position: "relative",
        }}
      >
        Testimonials
        <span
          style={{
            display: "block",
            width: "80px",
            height: "4px",
            background: "#FC4100",
            margin: "0.5rem auto 0",
            borderRadius: "2px",
          }}
        />
      </h2>

      <div className="row mt-3">
        <div className="col d-flex justify-content-end">
          <button
            onClick={() => scrollByCard(testinomialRef, -1)}
            className="btn btn-outline-primary rounded-circle me-2"
          >
            <FaArrowLeft />
          </button>
          <button
            onClick={() => scrollByCard(testinomialRef, 1)}
            className="btn btn-outline-primary rounded-circle"
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
      <div className="col-12 ">
        <SliderSectionLsNews
          title="latest News"
          images={testimonials}
          containerRef={testinomialRef}
        />
      </div>
    </div>
  );
};

export default Testimonials;

function SliderSectionLsNews({ images, containerRef }) {
  return (
    <div className="mt-4">
      <div
        className="d-flex"
        style={{
          overflowX: "auto",
          scrollbarWidth: "none",
          gap: "40px",
          padding: "10px 0",
        }}
        ref={containerRef}
      >
        {(images ?? []).map((item, index) => (
          <div
            className="mt-5 mb-3 ms-4"
            key={index}
            style={{
              flex: "0 0 auto",
              width: "400px",
              background: "#fff",
              borderRadius: "20px",
              position: "relative",
              padding: "2rem 1.5rem 1.5rem",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-20px",
                left: "-20px",
                background: "#ccc",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              “
            </div>

            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                overflow: "hidden",
                margin: "0 auto",
                marginTop: "-70px",
                border: "5px solid #fff",
                boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              }}
            >
              <img
                src={item.img}
                alt={item.author}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>

            <div className="text-center mt-3">
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#333",
                  lineHeight: "1.5",
                  height: "8em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {item.content}
              </p>

              <div style={{ marginTop: "1rem" }}>
                <h6 style={{ margin: 0, fontWeight: "bold" }}>{item.author}</h6>
                <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                  {item.designation}
                </p>

                <div
                  className="mt-2"
                  style={{ color: "#007bff", fontSize: "1rem" }}
                >
                  {item.review}
                </div>
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                right: "-20px",
                background: "#999",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              ”
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
